import { gql } from "@apollo/client";

export const GET_CONVERSATIONS = gql`
  query GetConversations {
    getConversations {
      _id
      participant {
        _id
        username
        email
      }
      lastMessage
      createdAt
      unreadCount
      postId
      postType
      postName
      postBreed
      postImageUrl
      postLocation
      postDate
    }
  }
`;

export const GET_UNREAD_COUNTS = gql`
  query GET_UNREAD_COUNTS {
    getConversations {
      _id
      unreadCount
    }
  }
`;